[{
        "category": "Legal Documents",
        "items": [
            { "abbreviation": "BOR", "description": "Broker of Record" },
            { "abbreviation": "MGA", "description": "Managing General Agent" },
            { "abbreviation": "RIAA", "description": "Reinsurance Intermediary Authorization Agreement" },
            { "abbreviation": "TPA", "description": "Third Party Administrator" }
        ]
    },
    {
        "category": "Marketing & Submission Terms",
        "items": [
            { "abbreviation": "WIN", "description": "Salesforce System" },
            { "abbreviation": "CUIS", "description": "Client Underwriter Information" },
            { "abbreviation": "ILW", "description": "Industry Loss Warranty" },
            { "abbreviation": "MGU", "description": "Managing General Underwriter" },
            { "abbreviation": "MOSAIC", "description": "RI-MS - Risk Intelligence - Market Security" },
            { "abbreviation": "SPV", "description": "Special Purpose Vehicle" },
            { "abbreviation": "CMA", "description": "Capital Market and Advisory" }
        ]
    },
    {
        "category": "General",
        "items": [
            { "abbreviation": "GEM", "description": "Gallagher Excellence Model" },
            { "abbreviation": "COO", "description": "Chief Operating Officer" },
            { "abbreviation": "SPOE", "description": "Second Pair of Eyes" }
        ]
    },
    {
        "category": "Responsibilities",
        "items": [
            { "abbreviation": "AT", "description": "Analytics Team" },
            { "abbreviation": "BT", "description": "Broking Team" },
            { "abbreviation": "CD", "description": "Contract Drafter" },
            { "abbreviation": "CSA", "description": "Client Service Advocate" },
            { "abbreviation": "CSM", "description": "Client Service Manager" },
            { "abbreviation": "OD", "description": "Operations Director" },
            { "abbreviation": "OS", "description": "Operations Specialist" },
            { "abbreviation": "OSM", "description": "Operations Specialist Manager" },
            { "abbreviation": "ROA", "description": "Regional Operations Analyst" }
        ]
    }
]